export const registration = "auth/register";
